// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as CampaignProgressBarCmp from "./CampaignProgressBarCmp.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

function CampaignMultiProgressBar(Props) {
  var progressBarList = Props.progressBarList;
  var labelTop = Props.labelTop;
  var labelBottom = Props.labelBottom;
  return React.createElement("div", {
              className: "ladder-progress-bar"
            }, React.createElement("div", {
                  className: "tags-container label-container"
                }, React.createElement("p", {
                      className: "amount"
                    }, labelTop), React.createElement("div", {
                      className: "sepratar"
                    }), React.createElement("p", {
                      className: "trip"
                    }, labelBottom)), ReasonReactUtils$Catalyst.listToReactArray(List.map((function (e) {
                        return React.createElement(React.Fragment, undefined, React.createElement(CampaignProgressBarCmp.make, {
                                        target: e.targetRange,
                                        current: e.current,
                                        status: e.status
                                      }), React.createElement("div", {
                                        className: "tags-container"
                                      }, React.createElement("p", {
                                            className: "amount"
                                          }, e.reward.toString()), React.createElement("div", {
                                            className: "sepratar"
                                          }), React.createElement("p", {
                                            className: "trip"
                                          }, String(e.target))));
                      }), progressBarList)));
}

var make = CampaignMultiProgressBar;

export {
  make ,
  
}
/* react Not a pure module */
